export default "__VITE_ASSET__C$6Y2lzE__"